import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLineitem = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#49454F",
		d: "M3.754 10.928c.206 0 .38-.07.519-.21a.706.706 0 0 0 .209-.52c0-.206-.07-.379-.21-.518a.706.706 0 0 0-.52-.21c-.206 0-.379.07-.518.21a.706.706 0 0 0-.21.52c0 .206.07.38.21.518.14.14.313.21.52.21Zm0-3.2c.206 0 .38-.07.519-.21A.706.706 0 0 0 4.482 7c0-.206-.07-.38-.21-.518a.706.706 0 0 0-.52-.21c-.206 0-.379.07-.518.21a.706.706 0 0 0-.21.52c0 .206.07.38.21.518.14.14.313.21.52.21Zm0-3.199c.206 0 .38-.07.519-.21a.706.706 0 0 0 .209-.519c0-.206-.07-.38-.21-.518a.706.706 0 0 0-.52-.21c-.206 0-.379.07-.518.21a.706.706 0 0 0-.21.52c0 .206.07.379.21.518.14.14.313.21.52.21Zm2.502 6.288h4.688V9.582H6.256v1.235Zm0-3.2h4.688V6.383H6.256v1.236Zm0-3.199h4.688V3.183H6.256v1.235ZM1.489 14c-.416 0-.768-.144-1.057-.432A1.437 1.437 0 0 1 0 12.51V1.49C0 1.073.144.72.432.432.721.144 1.072 0 1.49 0H12.51c.416 0 .768.144 1.057.432.288.289.432.64.432 1.057V12.51c0 .416-.144.768-.432 1.057-.289.288-.64.432-1.057.432H1.49Z"
	})
});
export { SvgLineitem as ReactComponent };
